import {
    FaWhatsapp,
    FaPhone,
    FaEnvelope,
  } from "react-icons/fa";
  import { BiHeart, BiStar } from "react-icons/bi";
  import { FiEye } from "react-icons/fi";
  import { Link } from "react-router-dom";
  import { otherProducts } from "../data/dummyData";
  
  const OtherProducts = () => {
    return (
      <div className="pt-16 max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 gap-3 mt-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {otherProducts.map(({ id, name, role, image }) => (
            <div className="relative h-[250px] w-full group" key={id}>
              {/* Image Section */}
              <img
                src={image}
                alt={name}
                className="object-cover w-full h-full rounded-lg transition-transform duration-300 group-hover:scale-95"
              />
  
              {/* Overlay Section */}
              <div className="absolute inset-0 bg-black/50 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="text-center text-white">
                  <h1 className="text-lg font-semibold">{name}</h1>
                  <p className="text-sm mb-4">{role}</p>
                  <div className="flex justify-center gap-x-3">
                    {/* Icons */}
                    <Link
                      to="#"
                      className="icon-box bg-primary hover:bg-secondary text-white p-2 rounded-full transition-all duration-300"
                    >
                      <FaWhatsapp />
                    </Link>
                    <Link
                      to="#"
                      className="icon-box bg-primary hover:bg-secondary text-white p-2 rounded-full transition-all duration-300"
                    >
                      <FaEnvelope />
                    </Link>
                    <Link
                      to="#"
                      className="icon-box bg-primary hover:bg-secondary text-white p-2 rounded-full transition-all duration-300"
                    >
                      <FaPhone />
                    </Link>
                  </div>
                </div>
              </div>
  
              {/* Bottom Card Section */}
             
            </div>
          ))}
        </div>
      </div>
    );
  };
  
  export default OtherProducts;
  